<template>
  <div class="app-main-inner app-main-page push-config">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" label-width="100px" label-position="right">
          <div class="el-form-item-wrapper">
            <el-form-item label-width="50px" :label="$t('SystemMaintenance.Branch')">
              <el-select v-model="branchId" @change="getPushConfig(branchId),getPersonalEmail(branchId)">
                <el-option
                  v-for="office in currentOfficeList"
                  :key="office.uuid"
                  :value="office.officeId"
                  :label="office.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="branchId!==1" :label="$t('SystemMaintenance.ApplyTheHeadOfficesSettings')">
              <el-checkbox v-model="pushConfigForm.ifApplied" @change="applyHeadOfficeConfig" />
            </el-form-item>
          </div>
        </el-form>
        <br>
        <el-button v-if="$checkPermission(['role_pushConfig_saveButton'])" type="primary" style="margin-left: 5px;" @click="saveConfig()">
          {{ $t('common.btn.save') }}
        </el-button>
      </div>
      <div class="triggers" />
    </div>
    <div class="app-main-inner-row">
      <el-form :disabled="pushConfigForm.ifApplied" label-width="120px" label-position="left">
        <div class="el-form-item-wrapper">
          <el-form-item label-width="5px">
            <el-checkbox v-model="pushConfigForm.ifAuto" :label="$t('SystemMaintenance.EnableAutomaticPush')" />
          </el-form-item>
        </div>
        <!--    基本配置    -->
        <div class="el-form-item-wrapper">
          <fieldset>
            <legend>{{ $t('SystemMaintenance.BasicConfiguration') }}</legend>
            <el-form-item label-width="200px" :label="$t('SystemMaintenance.SOPPushChannel')">
              <el-checkbox v-model="pushConfigForm.ifEmail">{{ $t('SystemMaintenance.Email') }}</el-checkbox>
              <el-checkbox v-model="pushConfigForm.ifNote">{{ $t('SystemMaintenance.SMS') }}</el-checkbox>
              <el-checkbox v-model="pushConfigForm.ifEnterpriseWechat">{{ $t('CargoMsg.Cargo_EnterpriseWechat') }}</el-checkbox>
            </el-form-item>
            <el-form-item label-width="200px" :label="$t('SystemMaintenance.PushOnlyAfterConfirmingRecipient')">
              <el-radio-group v-model="pushConfigForm.ifSop">
                <el-radio :label="true">{{ $t('SystemMaintenance.Open') }}</el-radio>
                <el-radio :label="false">{{ $t('SystemMaintenance.Close') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label-width="200px" :label="$t('queryJob.MatchingConditionsForPushSOPReceiver') + ':'">
              <el-checkbox v-model="pushConfigForm.ifAirline">{{ $t('queryJob.route') }}</el-checkbox>
            </el-form-item>
          </fieldset>
        </div>
        <!--    邮箱配置    -->
        <div v-show="pushConfigForm.ifEmail" class="el-form-item-wrapper">
          <fieldset>
            <el-tooltip effect="light" :content="$t('SystemMaintenance.PleaseSendersEmailWhichEmails')" placement="top-end">
              <legend>{{ $t('SystemMaintenance.EmailConfiguration') }}<i style="cursor:pointer;margin-left:4px;" class="el-icon-question" /></legend>
            </el-tooltip>

            <el-checkbox checked disabled>{{ $t('SystemMaintenance.SystemEmail') }}</el-checkbox>
            <el-form-item :label="$t('SystemMaintenance.Username2')">
              <el-input v-model="systemEmail" disabled />
            </el-form-item>

            <el-checkbox v-model="mailServerForm.enable" :true-label="1" :false-label="0">{{ $t('SystemMaintenance.CompanyEmail') }}</el-checkbox>
            <div style="display:flex;">
              <div>
                <el-form-item :label="$t('SystemMaintenance.Username2')">
                  <el-input v-model="mailServerForm.authSender" :disabled="!mailServerForm.enable" />
                </el-form-item>
                <el-form-item :label="$t('SystemMaintenance.EmailPasswordauthorizationCode')">
                  <input v-model="mailServerForm.authSenderPwd" class="password" type="password" :disabled="!mailServerForm.enable">
                </el-form-item>
                <el-form-item :label="$t('SystemMaintenance.EmailDisplayName')">
                  <el-input v-model="mailServerForm.senderMail" :disabled="!mailServerForm.enable" />
                </el-form-item>
                <el-form-item :label="$t('SystemMaintenance.SenderServer')">
                  <el-input v-model="mailServerForm.smtpHost" :disabled="!mailServerForm.enable" />
                </el-form-item>
                <el-form-item :label="$t('SystemMaintenance.Port')">
                  <el-input v-model="mailServerForm.smtpPort" :disabled="!mailServerForm.enable" />
                </el-form-item>
                <el-form-item :label="$t('Tool.UseSsl')">
                  <el-checkbox v-model="mailServerForm.smtpSsl" :true-label="1" :false-label="0" />
                </el-form-item>
              </div>
              <div style="display:flex;height:220px;">
                <span style="margin-left:30px;">{{ $t('SystemMaintenance.Signature') }}</span>
                <div>
                  <div style="width:400px;position:relative;height:200px;">
                    <div v-show="!mailServerForm.enable || pushConfigForm.ifApplied" class="mask" />
                    <quill-editor
                      ref="myQuillEditor"
                      v-model="mailServerForm.sign"
                      :options="editorOption"
                      style="height:150px;"
                      @change="onEditorChange($event)"
                    />
                  </div>
                  <div>
                    <el-checkbox v-model="mailServerForm.enableSign" :true-label="1" :false-label="0">{{ $t('SystemMaintenance.EnableSignature') }}</el-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <el-checkbox v-model="emailConfiguration.enable" :true-label="1" :false-label="0" @change="onPersonalEmailEnableChange">{{ $t('SystemMaintenance.PersonalEmail') }}</el-checkbox>
            <i style="cursor:pointer;margin-left:4px;" class="el-icon-question" @click="showPersonalEmailTip" />

            <!-- <el-form-item :label="$t('SystemMaintenance.Username2')">
              <el-input v-model="emailConfiguration.authSender" disabled />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.SenderServer')">
              <el-input v-model="emailConfiguration.smtpHost" :disabled="!emailConfiguration.enable" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Port')">
              <el-input v-model="emailConfiguration.smtpPort" type="number" :disabled="!emailConfiguration.enable" />
            </el-form-item> -->
          </fieldset>
        </div>
        <!--    短信配置    -->
        <div v-show="pushConfigForm.ifNote" class="el-form-item-wrapper">
          <fieldset>
            <legend>{{ $t('SystemMaintenance.SMSConfiguration') }}</legend>
            <el-form-item :label="$t('Message.ChineseAbbreviationOfTheCompany')">
              <el-input v-model="pushConfigForm.noteChinese" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.CompanyEnglishAbbreviation')">
              <el-input v-model="pushConfigForm.noteEnglish" />
            </el-form-item>
          </fieldset>
        </div>
      </el-form>
    </div>
    <!-- 个人邮箱提示 -->
    <el-dialog
      :visible.sync="personalEmailTipVisible"
      :title="$t('SystemMaintenance.SetPersonalEmail')"
      width="600px"
      :close-on-click-modal="false"
      custom-class="personal-email-tip"
    >
      <div style="display: flex;flex-direction: column;">
        <span style="color: red">{{ $t('SystemMaintenance.Note') }}:</span>
        <span style="color: red">{{ $t('SystemMaintenance.SetPersonalEmailNote1') }}</span>
        <span style="color: red">{{ $t('SystemMaintenance.SetPersonalEmailNote2') }}</span>
        <span>{{ $t('SystemMaintenance.SetPersonalEmailStep1') }}</span>
        <img
          src="@/assets/personalMailTip1.png"
          style="width: 250px"
        >
        <span>{{ $t('SystemMaintenance.SetPersonalEmailStep2') }}</span>
        <img
          src="@/assets/personalMailTip2.png"
          style="width: 400px"
        >
        <span>{{ $t('SystemMaintenance.SetPersonalEmailStep3') }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" style="padding-left: 40px;padding-right: 40px" @click="personalEmailTipVisible=false">{{ $t('Message.Close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getUserInfo } from '@/utils/auth'
import { Assert } from '@/utils/validate'
import * as userApi from '@/api/user'
import { Base64 } from 'js-base64'
import { quillEditor } from 'vue-quill-editor'
import {
  getPushConfig, savePushConfig
} from '@/api/sysManage/baseConfig/pushConfig'

export default {
  name: 'PushConfiguration',
  components: { quillEditor },
  data() {
    return {
      loading: false,
      branchId: null,
      initPushConfigForm: {
        officeId: null,
        ifAuto: false,
        ifApplied: false,
        ifEmail: false,
        ifNote: false,
        ifSop: false,
        noteChinese: '',
        noteEnglish: '',
        ifAirline: false,
        ifEnterpriseWechat: false
      },
      checkedEmailConfiguration: 0,
      checkedEditCompanyEmail: 0,
      editorOption: {
        modules: {
          toolbar: {
            container: [
              /* eslint-disable */
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              // ["blockquote", "code-block"], // 引用  代码块
              // [{ header: 1 }, { header: 2 }], // 1、2 级标题
              // [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
              // [{ script: "sub" }, { script: "super" }], // 上标/下标
              // [{ indent: "-1" }, { indent: "+1" }], // 缩进
              // [{'direction': 'rtl'}],                         // 文本方向
              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              // [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              // [{ font: [] }], // 字体种类
              // [{ align: [] }], // 对齐方式
              ["clean"], // 清除文本格式
              ["link", "image"], // 链接、图片
            ],
          }
        },
        placeholder: '请在这里添加产品描述', //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
        syntax: true, //语法检测
      },
      systemEmail:'',
      first: '',
      emailConfiguration: {
        authSender: '',
        smtpHost: '',
        smtpPort: '',
        sign:'',
        enableSign:'',
      },
      pushConfigForm: {},
      initMailServerForm: {
        authSender: '',
        authSenderPwd: '',
        senderMail: '',
        smtpHost: '',
        smtpPort: '',
        smtpTimeOut: 25000
      },
      mailServerForm: {
        authSender:'',
        authSenderPwd:'',
        senderMail:'',
        smtpHost:'',
        smtpPort:'',
        smtpSsl: 0
      },
      newMailServerForm:{},
      originPushConfig: {},
      originMailServer: {},
      personalEmailTipVisible: false
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  watch: {
    branchId: {
      immediate: true,
      handler(newVal) {
        this.$store.dispatch('settings/changeSetting', { key: 'tempBranchId', value: newVal })
      }
    }
  },
  mounted() {
    this.branchId = this.currentOfficeList[0].officeId
    this.getPushConfig(this.branchId)
    this.getPersonalEmail(this.branchId);
  },
  beforeDestroy() {
    this.$store.dispatch('settings/changeSetting', { key: 'tempBranchId', value: 0 })
  },
  methods: {
    // 邮箱保存
    async savePersonalMailbox() {
      const self = this
      const encryption = Base64.encode(self.mailServerForm.authSenderPwd)
      const data = [
        {
          authSender:self.systemEmail,
          ifSop:self.pushConfigForm.ifSop?true : false,
          branchId:self.branchId,
          ifAuto:self.pushConfigForm.ifAuto?true : false,
          mailType:'0',
        }
      ]
      if(self.mailServerForm.enable  || self.mailServerForm.first === '1'){
        data.push({
          ...self.mailServerForm,
          ifSop:self.pushConfigForm.ifSop?true : false,
          ifAuto:self.pushConfigForm.ifAuto?true : false,
          authSenderPwd: encryption,
          senderDisplayName:self.mailServerForm.senderMail,
          mailType:'1',
          branchId:self.branchId
        })
      }
      if(self.emailConfiguration.enable || self.emailConfiguration.first === '1'){
        data.push({
          ...self.emailConfiguration,
          ifSop:self.pushConfigForm.ifSop?true : false,
          ifAuto:self.pushConfigForm.ifAuto?true : false,
          mailType:'2',
          branchId:self.branchId,
          enable:self.emailConfiguration.enable
        })
      }
      await self.checkForm()
      const saveInfo = await userApi.updatePersonalEmail(data).then(res=>res.data)
      if(saveInfo){
        self.getPersonalEmail(self.branchId);
      }
    },
    // 获取个人邮箱信息
    async getPersonalEmail(branchId) {
      const self = this;
      self.mailServerForm = {
        authSender: '',
        authSenderPwd: '',
        senderMail: '',
        smtpHost: '',
        smtpPort: '',
        uuid:'',
        enable:0,
        first: '',
        sign:'',
        enableSign:'0',
        smtpTimeOut: 25000
      }
      self.emailConfiguration = {
        authSender: self.$store.getters.userInfo.email,
        smtpHost: '',
        mailType: '2',
        smtpPort: '',
        first:'',
        enable:0,
      }
      const data = {
        mailType: '',
        branchId: branchId
      }
      const personalInfo = await userApi.getPersonalEmail(data).then(resp => resp.data)
      if(personalInfo){
        personalInfo.forEach((item)=>{
          switch(item.mailType){
            case '0':
              self.systemEmail = item.authSender;
              break;
            case '1':
              self.mailServerForm = {...item}
              self.mailServerForm.first = '1'
              self.mailServerForm.senderMail = item.senderDisplayName
              self.mailServerForm.authSenderPwd = Base64.decode(item.authSenderPwd)
              self.originMailServer = { ...self.mailServerForm }
              break;
            case '2':
              self.emailConfiguration = {...item}
              self.emailConfiguration.first = '1'
              if(!item.authSender){
                self.emailConfiguration.authSender = self.$store.getters.userInfo.email
              }
              break;
          }
        })
      }
    },
    
    // 值发生变化
    onEditorChange(editor) {
      this.emailConfiguration.sign = editor.html
    },
    getPushConfig(value) {
      const self = this
      this.loading = getLoading()
      getPushConfig(value).then(result => {
        if(result.data.mailServer.authSenderPwd){
          result.data.mailServer.authSenderPwd = Base64.decode(result.data.mailServer.authSenderPwd)
        }
        self.pushConfigForm = result.data.sopPushConfig ? result.data.sopPushConfig : { ...this.initPushConfigForm }
        self.newMailServerForm = result.data.mailServer ? result.data.mailServer : { ...this.initMailServerForm }
        self.originPushConfig = { ...self.pushConfigForm }
        // self.originMailServer = { ...self.newMailServerForm }
      }).finally(
        self.loading.close()
      )
    },
    saveConfig: async function() {
      const self = this
      // 获取最新的个人邮箱信息
      if(self.emailConfiguration.enable || self.emailConfiguration.first === '1'){
        const personalInfo = await userApi.getPersonalEmail({ mailType: '2', branchId: self.branchId }).then(resp => resp.data[0])
        if(personalInfo){
          const { enable, first, authSender } = self.emailConfiguration
          self.emailConfiguration = { ...personalInfo, enable, first, authSender }
        }
      }
      const saveData = {}
      // let newMailServerForm;
      await self.checkForm()
      if (!self.pushConfigForm.ifApplied) {
        // if (this.pushConfigForm.ifEmail) {
        //   this.newMailServerForm.smtpTimeOut = 25000
        //   this.newMailServerForm.smtpSsl = 0
        //   this.newMailServerForm.branchId = this.branchId
        //   this.newMailServerForm.ifAuto = this.pushConfigForm.ifAuto
        //   this.newMailServerForm.ifSop = this.pushConfigForm.ifSop
        //   newMailServerForm = Object.assign({},this.newMailServerForm)
        //   newMailServerForm.authSenderPwd = Base64.encode(newMailServerForm.authSenderPwd)
        //   saveData.mailServer = newMailServerForm
        // }
        if (!this.pushConfigForm.ifNote) {
          this.pushConfigForm.noteChinese = ''
          this.pushConfigForm.noteEnglish = ''
        }
        this.pushConfigForm.officeId = this.branchId
        saveData.sopPushConfig = this.pushConfigForm
      } else {
        saveData.sopPushConfig = {
          uuid: this.pushConfigForm.uuid,
          ifApplied: this.pushConfigForm.ifApplied,
          version: this.pushConfigForm.version,
          officeId: this.branchId
        }
      }
      this.loading = getLoading()
      self.savePersonalMailbox()
      savePushConfig(saveData).then(() => {
        self.originPushConfig = { ...self.pushConfigForm }
        self.originMailServer = { ...self.mailServerForm }
        self.$message.success(self.$t('common.tips.saveSuccess'))
        self.getPushConfig(self.branchId)
      }).finally(
        self.loading.close()
      )
    },
    applyHeadOfficeConfig(value) {
      const target = value
      if (value) {
        this.pushConfigForm = { ...this.originPushConfig }
        this.mailServerForm = { ...this.originMailServer }
        this.pushConfigForm.ifApplied = target
      }
    },
    // 提交验证
    async checkForm() {
      const self = this;
      if (self.pushConfigForm.ifNote) {
        const { noteChinese, noteEnglish } = { ...self.pushConfigForm }
        await Assert.isNotBlank(noteChinese, this.$t('SystemMaintenance.CompanyAbbreviationCannotBeEmpty'))
        await Assert.isNotBlank(noteEnglish, this.$t('Message.TheTheCompanyCannotEmpty'))
      }
      if (self.pushConfigForm.ifEmail) {
        const { authSender, authSenderPwd, smtpHost, smtpPort } = { ...self.mailServerForm }
        if(Number(self.mailServerForm.enable)){
          await Assert.isNotBlank(authSender, this.$t('SystemMaintenance.CompanyUsernameCannotBeEmpty'))
          await Assert.isNotBlank(authSenderPwd, this.$t('SystemMaintenance.CompanyCodeCannotBeEmpty'))
          await Assert.isNotBlank(smtpHost, this.$t('SystemMaintenance.CompanyServerCannotBeEmpty'))
          await Assert.isNumber(smtpPort, this.$t('SystemMaintenance.CompanyNumberMustBeNumber'))
        }
        
        if(Number(self.emailConfiguration.enable)){
          await Assert.isNotBlank(self.emailConfiguration.authSender, this.$t('SystemMaintenance.PersonalUsernameCannotBeEmpty'))
          await Assert.isNotBlank(self.emailConfiguration.smtpHost, this.$t('SystemMaintenance.PersonalServerCannotBeEmpty'))
          await Assert.isNumber(self.emailConfiguration.smtpPort, this.$t('SystemMaintenance.PersonalNumberMustBeNumber'))
        }
        
      }
    },
    onPersonalEmailEnableChange() {
      if (this.emailConfiguration.enable) {
        this.$store.dispatch('settings/changeSetting', { key: 'settingAndToolsVisible', value: true })
      }
    },
    showPersonalEmailTip() {
      this.personalEmailTipVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.push-config fieldset {
  background: #fff;
  border: #e6ebf5 solid 2px;
  border-radius: 5px;
  padding: 10px 30px;
}
.push-config fieldset legend {
  font-size: 14px;
  padding-top: 5px;
}
.mask{
  position: absolute;
  width: 100%;
  height: 100%;
  background: #ccc;
  opacity: 0.2;
  z-index: 999;
}
.password{
  height:28px;
  text-indent: 5px;
  border: 1px solid #DCDFE6;
  &:focus{ 
    outline-style: none;
    border: 1px solid #226cc1;
    border-radius: 1px;
  }
}
.push-config::v-deep .el-dialog.personal-email-tip {
  margin-top: 1vh !important;
  margin-bottom: 1vh;
  line-height: 16px;
}
</style>
